import { STORAGE_KEYS } from '../../config/miaw/constants';
import { getItemInWebStorageByKey, setItemInWebStorage } from './web-storage-utils';

// Store the Org Id for other components to use.
const storeOrganizationId = (organizationId: string) => {
  setItemInWebStorage(STORAGE_KEYS.ORGANIZATION_ID, organizationId);
};

const getOrganizationId = () => {
  return getItemInWebStorageByKey(STORAGE_KEYS.ORGANIZATION_ID);
};

// Store the Embedded Service Deployment Developer Name for other components to use.
const storeDeploymentDeveloperName = (deploymentDevName: string) => {
  setItemInWebStorage(STORAGE_KEYS.DEPLOYMENT_DEVELOPER_NAME, deploymentDevName);
};

const getDeploymentDeveloperName = () => {
  return getItemInWebStorageByKey(STORAGE_KEYS.DEPLOYMENT_DEVELOPER_NAME);
};

// Store the Salesforce Url from the Embedded Service Deployment for other components to use.
const storeSalesforceMessagingUrl = (messagingUrl: string) => {
  setItemInWebStorage(STORAGE_KEYS.MESSAGING_URL, messagingUrl);
};

const getSalesforceMessagingUrl = () => {
  return getItemInWebStorageByKey(STORAGE_KEYS.MESSAGING_URL);
};

// Store the Salesforce Access Token (JWT) for other components to use.
const setJwt = (jwt: string) => {
  setItemInWebStorage(STORAGE_KEYS.JWT, jwt);
};

const getJwt = () => {
  return getItemInWebStorageByKey(STORAGE_KEYS.JWT);
};

// Store the configuration settings of the Embedded Service Deployment for other components to use.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setDeploymentConfiguration = (configuration: any) => {
  setItemInWebStorage(STORAGE_KEYS.DEPLOYMENT_CONFIGURATION, JSON.stringify(configuration));
};

const getDeploymentConfiguration = () => {
  const configuration = getItemInWebStorageByKey(STORAGE_KEYS.DEPLOYMENT_CONFIGURATION);
  if (!configuration) {
    return;
  }
  return JSON.parse(configuration);
};

// Store the latest last-event-id from the Access Token API response or from an Event Source (SSE) event in-memory.
let lastEventId: string | undefined;

const setLastEventId = (id: string) => {
  lastEventId = id;
};

const getLastEventId = () => {
  return lastEventId;
};

// Store the conversation-id for the current conversation in-memory for other components to use.
let conversationId: string | undefined;

const storeConversationId = (convId: string) => {
  conversationId = convId;
};

const getConversationId = () => {
  return conversationId;
};

// Clears the in-memory messaging data variables.
const clearInMemoryData = () => {
  conversationId = undefined;
  lastEventId = undefined;

  console.log('Cleared in-memory data.');
};

export {
  clearInMemoryData,
  getConversationId,
  getDeploymentConfiguration,
  getDeploymentDeveloperName,
  getJwt,
  getLastEventId,
  getOrganizationId,
  getSalesforceMessagingUrl,
  setDeploymentConfiguration,
  setJwt,
  setLastEventId,
  storeConversationId,
  storeDeploymentDeveloperName,
  storeOrganizationId,
  storeSalesforceMessagingUrl,
};
